import React from 'react';
import { Link } from 'react-router-dom';
import { popularDestinations } from '../mock/mock';
import { Card, CardContent } from '../components/ui/card';
import { ArrowRight } from 'lucide-react';

const continents = [
  { name: 'Southeast Asia', cities: ['Bangkok','Bali','Kuala Lumpur','Jakarta','Manila','Ho Chi Minh City'] },
  { name: 'North Asia', cities: ['Tokyo','Seoul','Taipei','Hong Kong','Osaka','Shanghai'] },
  { name: 'Europe', cities: ['London','Paris','Rome','Amsterdam','Barcelona','Zurich'] },
  { name: 'Oceania', cities: ['Sydney','Melbourne','Auckland','Perth','Brisbane','Queenstown'] },
  { name: 'Middle East', cities: ['Dubai','Abu Dhabi','Doha','Istanbul','Muscat','Riyadh'] },
  { name: 'Americas', cities: ['New York','Los Angeles','San Francisco','Toronto','Vancouver','Rio de Janeiro'] },
];

export default function Destinations() {
  return (
    <div>
      <section className="bg-teal-800 py-14 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-teal-200 uppercase tracking-widest text-xs font-semibold">Destinations</div>
          <h1 className="font-display font-extrabold text-3xl md:text-5xl mt-2">Where would you like to go?</h1>
          <p className="text-white/85 mt-3 max-w-2xl">Discover routes, average fares and travel inspiration for hundreds of destinations — direct from Singapore.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <h2 className="font-display font-extrabold text-2xl text-slate-900 mb-6">Trending destinations</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {popularDestinations.map(d => (
            <Link to="/flights" key={d.id} className="group relative overflow-hidden rounded-2xl aspect-[4/5] card-lift">
              <img src={d.image} alt={d.city} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
              <div className="absolute inset-0 p-4 flex flex-col justify-end text-white">
                <div className="text-xs uppercase tracking-widest text-white/70">{d.country}</div>
                <div className="font-display font-extrabold text-xl">{d.city}</div>
                <div className="mt-2 flex items-center justify-between">
                  <div className="font-display font-extrabold text-lg">S${d.price}</div>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 pb-16">
        <h2 className="font-display font-extrabold text-2xl text-slate-900 mb-6">Browse by region</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {continents.map(c => (
            <Card key={c.name} className="border-slate-200">
              <CardContent className="p-5">
                <div className="font-display font-bold text-slate-900 mb-3">{c.name}</div>
                <div className="grid grid-cols-2 gap-y-1.5 gap-x-2">
                  {c.cities.map(city => (
                    <Link key={city} to="/flights" className="text-sm text-slate-700 hover:text-teal-700">{city}</Link>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
